import { useCallback } from "react";
import { UpdateOrganizationDTO } from "@src/domain/dto/organizations";
import { UpdateOrganizationUseCase } from "@src/application/useCases/organization";
import { OrganizationRepository } from "@src/infrastructure/repositories/organization";
import { GraphQlAdapter } from "@src/infrastructure/adapters/graphQl/GraphQl.adapter";

export type UpdateOrganizationPayload = {
  organizationId?: number | null;
  organizationKey: string;
  organizationName: string;
  organizationDisplayName: string;
  organizationDescription?: string | null;
  organizationIsActive: boolean;
  organizationLogoFile?: File | null;
  organizationLogoUrl?: string | null;
  organizationLogoRemove?: boolean;
};

export function useUpdateOrganization() {
  return useCallback(async (payload: UpdateOrganizationPayload) => {
    const validated = UpdateOrganizationDTO.validate(payload);
    if (!validated.success) {
      console.error("UpdateOrganization validation failed", validated.error);
      throw new Error("Invalid organization data");
    }
    const dto = new UpdateOrganizationDTO(validated.data);
    return new UpdateOrganizationUseCase(
      new OrganizationRepository(GraphQlAdapter.getInstance().getClient()),
    ).execute(dto);
  }, []);
}
